import { z } from 'zod';

/**
 * Preferências de leitura de cada pessoa (ADR 0128, fase 6): valem só para ela, por cima do
 * estilo do sistema. O modo escuro só aparece quando o estilo tem escuro (gerado da paleta).
 */
export const THEME_MODES = ['system', 'light', 'dark'] as const;
export type ThemeMode = (typeof THEME_MODES)[number];

export const userPreferencesSchema = z
  .object({
    themeMode: z.enum(THEME_MODES),
    largeText: z.boolean(),
    highContrast: z.boolean(),
    /** No modo claro, o menu lateral também claro (ADR 0138). Quem não manda fica com o do estilo. */
    lightMenu: z.boolean().default(false),
  })
  .strict();
export type UserPreferences = z.output<typeof userPreferencesSchema>;

export const DEFAULT_PREFERENCES: UserPreferences = {
  themeMode: 'system',
  largeText: false,
  highContrast: false,
  lightMenu: false,
};

/** O modo que vale agora: o escolhido, ou o do aparelho quando a pessoa deixou "do aparelho". */
export function resolvedThemeMode(mode: ThemeMode, deviceDark: boolean): 'light' | 'dark' {
  return mode === 'system' ? (deviceDark ? 'dark' : 'light') : mode;
}
